import { useState } from 'react'
import axiosPublic from '../../utils/axios_public'
import { useNavigate, Link } from 'react-router-dom'
import '../../../css/forgotPW.css'
import { useTranslation } from 'react-i18next'; // Import useTranslation


function ForgotPassword() {

    const [email, setEmail] =useState("")
    const [isLoading, setIsLoading] =useState(false)
    const { t } = useTranslation(); // Initialize useTranslation

    const navigate = useNavigate()

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);

    const handleSubmit = async () => {
        setIsLoading(true)
        try {
            await axiosPublic.get(`user/password-reset/${email}/`).then((res) => {
                alert("An Email has been sent to you.")
                setIsLoading(false)
                //navigate("/create-new-password") not appropiate
            })
        } catch (error) {
            alert("An error occured")
            setIsLoading(false)
        }
    }

  return (
    <>
        <div className="activate-account-container">
            <div className="form-inner-container-2">
            {/* Email input */}
                <h1 className="font">{t("forgotPassword.header")}</h1>
                <p className="desc-text font pd-t5 pd-b5">{t("forgotPassword.message.enterMail")}<br></br> {t("forgotPassword.message.sentMail")}</p>
                <div className="form-input-container-1">
                    <label className="form-label-1" htmlFor="Full Name">
                    {t("forgotPassword.labels.email")}
                    </label>
                    <input
                        type="text"
                        id="loginName"
                        name="email"
                        value={email}
                        className="form-input-1 bgc"
                        onChange={(e) => setEmail(e.target.value)}

                    />
                </div>
                
                { isLoading === true
                    ?   <button disabled
                                type='button'
                                className='form-button-submit-1'                                                                 
                                //disabled={"isLoading"}
                            >
                                <span className="mr-2">Processing...</span>
                        </button>
                    :   <button onClick={handleSubmit}
                                type='button'
                                className='form-button-submit-1' 
                                //disabled={"isLoading"}
                            >
                                <span className="mr-2">{t("forgotPassword.message.sendMail")}</span>
                                <i className="fas fa-paper-plane" />
                        </button>
                }
                                                                                                        
                <div className="">
                    <p className='font'>
                    {t("forgotPassword.message.want_to_sign_in")} <Link className="sign-up-link" to="/login">Login</Link>
                    </p>
                </div>
            </div>
        </div>
    </>                             
  )
}

export default ForgotPassword